import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorAdminService } from "../../services/api/vendor-admin.service";
import { VendorAchActions } from "../actions/vendor-ach.actions";
import { FailState } from "../models/fail-state";

@Injectable()
export class VendorAchEffects {
	nameChangeRequested = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAchActions.nameChangeRequested),
			switchMap((action) => {
				return this.vendorAdminService
					.updateBankAccountName(action.accountId, action.accountName, action.isActive)
					.pipe(
						map(() => VendorAchActions.namedChanged()),
						catchError((error) =>
							of(VendorAchActions.nameChangeFailed(new FailState(error)))
						)
					);
			})
		)
	);

	createAccount = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAchActions.createAccount.create),
			switchMap((action) => {
				return this.vendorAdminService.createAchCustomer(action.achAccountInfo).pipe(
					map((achCommerceId) =>
						VendorAchActions.createAccount.createSuccess({ achCommerceId })
					),
					catchError((error) =>
						of(VendorAchActions.createAccount.createFail(new FailState(error)))
					)
				);
			})
		)
	);

	constructor(
		private actions: Actions,
		private vendorAdminService: VendorAdminService
	) {}
}
